__turbopack_context__.v({
  "languageSelector": "LanguageSelector-module-scss-module__3YpmiW__languageSelector",
  "select": "LanguageSelector-module-scss-module__3YpmiW__select",
});
